import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GoogleBigQueryLinkedService } from './google-bigquery.linkedservice';

@Metamodel.model({
    name: __IS_FABRIC_DPE__
        ? adfModelTypeMap.googleBigQuery.linkedServiceType
        : adfModelTypeMap.googleBigQueryV2.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.GoogleBigQuery_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.GoogleBigQuery_DisplayText)
    ]
})
export class GoogleBigQueryV2LinkedService extends LinkedService {
    public static readonly MODEL: IModel;

    public static readonly PROJECT_ID: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;
    public static readonly REFRESH_TOKEN: IAttribute;
    public static readonly KEY_FILE_CONTENT: IAttribute;

    @Metamodel.attribute({
        display: stringResources.VersionLabel
    })
    public version?: string;
    @Metamodel.attribute({
        display: stringResources.ModelName_ProjectID,
        association: 'PROJECT_ID',
        templatable: true
    })
    public projectId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: true
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'CLIENT_SECRET',
        templatable: true,
        accepts: ['String']
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_RefreshToken,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'REFRESH_TOKEN',
        templatable: true,
        accepts: ['String']
    })
    public refreshToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_KeyFile,
        association: 'KEY_FILE_CONTENT',
        templatable: true,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        accepts: ['String']
    })
    public keyFileContent?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public convertV1toV2(context: { inlineDataset?: boolean }): GoogleBigQueryV2LinkedService {
        const secrets: Array<keyof GoogleBigQueryV2LinkedService> = ['refreshToken', 'clientSecret'];
        secrets.forEach((key) => {
            if (!(this[key] instanceof AzureKeyVault)) {
                delete this[key];
            }
        });
        this.projectId = (this as GoogleBigQueryLinkedService).project;
        return this;
    }
}
